import { getAptSizeMapAPI, getLeakUnitsAPI, getOveruseUnitsAPI } from "@/apis/apt-api"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { create } from "zustand"
import { createAptMonitoringMap } from "./monitoring-const"

export const monitoringStore = create((set) => ({
  aptSizeMap: {},
  aptMonitoringMap: {},
  summary: {},
  history: [],

  initialize: async () => {
    const { sido, kapt_code } = aptSearchStore.getState().pickApt
    const [aptSizeMap, overuseResult, leakResult] = await Promise.all([
      getAptSizeMapAPI({ kapt_code }),
      getOveruseUnitsAPI({ sido, kapt_code, dong: "all" }),
      getLeakUnitsAPI({ sido, kapt_code, dong: "all" })
    ])

    const {
      monitoringMap: aptMonitoringMap,
      summary,
      history
    } = createAptMonitoringMap(aptSizeMap, overuseResult.overuse_units, leakResult.leak_units)

    set({
      summary,
      aptSizeMap,
      aptMonitoringMap,
      history
    })
  },

  reset: () => {
    set({
      aptSizeMap: {},
      aptMonitoringMap: {},
      summary: {},
      history: []
    })
  }
}))
